import React, { useEffect, useState } from 'react';
import '../../../assets/style/KnowledgeCenter.css';
import {
  alertPopupToggle,
  defaultData,
  handleCancel,
  handleSubmit,
  onRemove,
} from './knowledgeCenterHelper';
import { Image } from 'react-bootstrap';
import classNames from 'classnames';
import successTickIcon from '../../../assets/img/success-vector.svg';
import { PdfType, VideoPreviewType } from '../../../utils/Types';
import PdfsPreview from '../gallery/PdfsPreview';
import VideosPreview from '../welcome-videos/VideosPreview';
import { useAppDispatch, useAppSelector } from '../../../store/redux-hooks';
import {
  knowledgeCenterSelector,
  getKnowLedgeCenterMedia,
  getTypes,
} from '../../../features/knowledgeCenterSlice';
import CenterSpinner from '../../../components/CenterSpinner';
import { Col, Label, Row } from 'reactstrap';
import MediaThumbnailUpload from '../../../components/MediaThumbnailUpload';
import { API_STATUS, maxFilesInAdminSettings } from '../../../utils/Constant';
import AlertPopUP from '../../modals/AlertPopUp';
import { useLoader } from '../../../loader/LoaderProvider';

const KnowledgeCenterPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const knowledgeCenterTabs = useAppSelector(knowledgeCenterSelector).tabs;
  const [activeTab, setActiveTab] = useState<number>(0);
  const { showLoader, setShowLoader } = useLoader();
  const [data, setData] = useState(defaultData);
  const [pdfsList, setPdfsList] = useState<PdfType[]>([]);
  const [videosList, setVideosList] = useState<VideoPreviewType[]>([]);
  const [showAlertPopUp, setShowAlertPopUp] = useState<boolean>(false);
  const [removeMediaId, setRemoveMediaId] = useState<any>('');

  const knowledgeCenterMediaFiles = useAppSelector(
    knowledgeCenterSelector
  ).media;
  const apiStatus: string = useAppSelector(knowledgeCenterSelector).status;

  useEffect(() => {
    setData(defaultData);
    dispatch(getKnowLedgeCenterMedia({ type: activeTab }));
  }, [activeTab]);

  useEffect(() => {
    const pdfList: PdfType[] = knowledgeCenterMediaFiles.pdfs?.map((pdf) => {
      return {
        url: pdf.knowledgeCenterUrl,
        id: pdf.knowledgeCenterId,
        size: pdf.knowledgeCenterSize,
        name: pdf.knowledgeCenterTitle,
        thumnailUrl: pdf.knowledgeCenterThumbnail,
        createdOn: pdf.createdOn,
        order: pdf.knowledgeCenterOrder,
      };
    });

    const videoList: VideoPreviewType[] = knowledgeCenterMediaFiles.videos?.map(
      (video) => {
        return {
          url: video.knowledgeCenterUrl,
          id: video.knowledgeCenterId,
          size: video.knowledgeCenterSize,
          name: video.knowledgeCenterTitle,
          thumbnail: video.knowledgeCenterThumbnail,
          createdOn: video.createdOn,
          order: video.knowledgeCenterOrder,
        };
      }
    );

    setPdfsList(pdfList ?? []);
    setVideosList(videoList ?? []);
  }, [knowledgeCenterMediaFiles]);

  useEffect(() => {
    if (apiStatus === API_STATUS.FAILED || apiStatus === API_STATUS.SUCCEEDED) {
      setShowLoader(false);
    } else {
      setShowLoader(true);
    }
  }, [apiStatus]);

  useEffect(() => {
    dispatch(getTypes());
  }, []);

  useEffect(() => {
    if (knowledgeCenterTabs?.length) {
      setActiveTab(knowledgeCenterTabs[0].knowledgeCenterTypeId);
    }
  }, [knowledgeCenterTabs]);

  return (
    <div className="ml-4">
      <Label className="text-heading">Knowledge Centre</Label>
      <div className="task-item-parent-view bg-white">
        <div className=" border rounded">
          <div className="d-flex kc-header p-3 gap-1">
            {knowledgeCenterTabs?.map((tab) => (
              <button
                className={classNames(' kc-tab p-2 button-container', {
                  active: activeTab === tab.knowledgeCenterTypeId,
                })}
                key={tab.knowledgeCenterTypeName}
                onClick={() => {
                  setActiveTab(tab.knowledgeCenterTypeId);
                }}
              >
                {activeTab === tab.knowledgeCenterTypeId && (
                  <Image
                    className="tick-icon"
                    src={successTickIcon}
                    width={20}
                    height={20}
                  />
                )}
                <Row className="d-flex align-items-center flex-column">
                  <Col>
                    <Image
                      src={tab.opsIconUrl}
                      width={60}
                      height={60}
                      alt={`${tab.knowledgeCenterTypeName}-icon`}
                    />
                  </Col>
                  <Col>{tab.knowledgeCenterTypeName}</Col>
                </Row>
              </button>
            ))}
          </div>
        </div>
        <div className="mt-3">
          <MediaThumbnailUpload
            data={data}
            onSubmit={() => {
              handleSubmit(data, setData, activeTab, setShowLoader, dispatch);
            }}
            setData={setData}
            onCancel={() => {
              handleCancel(setData);
            }}
            disabled={
              pdfsList?.length + videosList?.length >=
              maxFilesInAdminSettings.knowledgeCenter
            }
          />
        </div>

        {pdfsList.length || videosList.length ? (
          <div className="mt-3 border rounded p-3">
            <div>
              <PdfsPreview
                pdfs={pdfsList}
                handleRemove={(id: number | string) => {
                  onRemove(id, setShowAlertPopUp, setRemoveMediaId);
                }}
              />
            </div>
            <div className="mt-3">
              <VideosPreview
                videos={videosList}
                handleRemove={(id: number | string) => {
                  onRemove(id, setShowAlertPopUp, setRemoveMediaId);
                }}
                cancelWithBg
              />
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
      <CenterSpinner showLoader={showLoader} />
      {showAlertPopUp && (
        <AlertPopUP
          isOpen={showAlertPopUp}
          toggle={(action: string) => {
            alertPopupToggle(
              action,
              removeMediaId,
              activeTab,
              setShowAlertPopUp,
              setRemoveMediaId,
              setShowLoader,
              dispatch
            );
          }}
        />
      )}
    </div>
  );
};

export default KnowledgeCenterPage;
